<template>
<div>
    <v-select
        :label="label"
        :items="choices"
        v-model="internal_value"
        return-object
        v-on:input="onChange"
        :rules="select_rules"
    />
</div>
</template>

<script>
export default {

    props: {

        organization_id: {
            type: String,
            default: function() { return null; }
        },

        value: {
            type: String,
            default: function() { return null; },
        },

        label: {
            type: String,
            default: function() { return 'Location'; },
        },

        required: {
            type: Boolean,
            default: function() { return false; },
        },

        include_all_locations: {
            type: Boolean,
            default: function() { return false; },
        },
    },

    data() {
        return {
            internal_value: null,
            choices: [],
            rules: {
                required: (value) => { if ( value == null ) return 'Required'; return true;  },
            },
        }
    },

    mounted () {
        this.updateLocations();
    },

    methods: {
        updateLocations() {
            
            
            if ( this.organization_id == null )
            {
                this.choices = [];
                this.internal_value = null;
                return;
            }

            let location_search = {
                'search' : {
                    'organization_id' : this.organization_id,
                    'archived' : false,
                },
            };

           
            this.$rc.showSpinner();
            
            this.$rc.searchLocations(
                location_search,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.choices = this.createChoices(data.locations);
                    this.internal_value = this.createInternalValue(this.value);
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to list locations');
                },
            );
        },

        createChoices(locations)
        {
            let ret = [];

            if ( this.include_all_locations )
            {
                ret.push({
                    'text' : 'All Locations',
                    'value' : '*',
                });
            }

            for ( let i = 0; i < locations.length; i++ )
            {
                ret.push({
                    'text' : locations[i].internal_label,
                    'value' : locations[i].location_id,
                });
            }

            return ret;
        },

        createInternalValue(value)
        {
            let choices = this.choices;

            for ( let i = 0; i < choices.length; i++ )
            {
                if ( choices[i].value == value )
                    return choices[i];
            }

            return null;
        },

        onChange(value)
        {
            this.$emit('input',value.value);
        },
    },

    computed: {
        select_rules() {
            
            if ( this.required == true ) 
                return [this.rules.required];

            return [];
        }
    },

    watch: {
        organization_id(newValue, oldValue) {
            this.updateLocations();
        },

        include_all_locations(newValue, oldValue) {
            this.updateLocations();
        },

        value(newValue, oldValue) {
            this.internal_value = this.createInternalValue(newValue);
        },
    },
}
</script>

<style lang="scss" scoped>

</style>